import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import instanceAPI from '../config/axiosconfig';

export const getRecentWinners = createAsyncThunk(
  'recentWinners/getRecentWinners',
  async () => {
    const recentWinners = await instanceAPI.get('/get-recent-winners')
      .then((resp) => resp.data.winners);
    return recentWinners;
  },
);

const recentWinnersSlice = createSlice({
  name: 'winners',
  initialState: {
    recentWinners: [],
    status: null,
  },
  extraReducers: {
    [getRecentWinners.pending]: (state) => {
      state.status = 'loading';
    },
    [getRecentWinners.fulfilled]: (state, action) => {
      state.status = 'success';
      state.recentWinners = action.payload;
    },
    [getRecentWinners.rejected]: (state) => {
      state.status = 'failed';
    },
  },
});

export default recentWinnersSlice.reducer;
